import { render, staticRenderFns } from "./IconProofreadPending.vue?vue&type=template&id=2e2ad223&"
import script from "./IconProofreadPending.vue?vue&type=script&lang=js&"
export * from "./IconProofreadPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2ad223')) {
      api.createRecord('2e2ad223', component.options)
    } else {
      api.reload('2e2ad223', component.options)
    }
    module.hot.accept("./IconProofreadPending.vue?vue&type=template&id=2e2ad223&", function () {
      api.rerender('2e2ad223', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconProofreadPending.vue"
export default component.exports